module.exports = {
      id: "subscribe-vikatan-usage",
      viewBox: "0 0 365.232 27",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#subscribe-vikatan",
      toString: function () {
        return this.url;
      }
    }